module.exports = __webpack_public_path__ + "static/media/writing_sample.faf290f9.jpg";